import "../../assets/style/admin.css";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ErrorPage from "../ErrorPage";
import useIsAdmin from "../../hooks/useIsAdmin";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingContent from "../../components/LoadingContent";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";

const AdminHome = () => {
  const [loading, setLoading] = useState(true);
  document.title = "LVF1 - Admin";
  const { typeUser } = useIsAdmin();

  const chartRef = useRef<any>(null);
  const chartRef2 = useRef<any>(null);
  const chartRoot1 = useRef<any>(null);
  const chartRoot2 = useRef<any>(null);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);
  const toggleMenu = (menu: string) =>
    setActiveMenu((prev) => (prev === menu ? null : menu));

  const toggleSubmenu = (submenu: string) =>
    setActiveSubmenu((prev) => (prev === submenu ? null : submenu));

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/data`
      )
      .then(({ data }) => {
        setData(data);
      })
      .catch(({ response }) => {
        console.log(response);
      });
  }, []);

  useLayoutEffect(() => {
    if (data != null) {
      if (chartRoot1.current != null) {
        chartRoot1.current.dispose();
      }
      if (chartRoot2.current != null) {
        chartRoot2.current.dispose();
      }

      chartRoot1.current = showChart(chartRef, data.latestOrigins);
      chartRoot2.current = showChart(chartRef2, data.countOrigins);

      return () => {
        chartRoot1.current?.dispose();
        chartRoot2.current?.dispose();
      };
    }
  }, [data]);

  const showChart = (ref: any, data: any) => {
    if (!ref.current) return;
    const root = am5.Root.new(ref.current);

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "key",
        legendLabelText: "{category}",
        legendValueText: "{value}",
      })
    );

    series.labels.template.set(
      "text",
      "{category} ({value.formatNumber('#,###')})"
    );

    series.slices.template.setAll({
      strokeWidth: 0,
      stroke: am5.color(0x000000),
      strokeOpacity: 0,
    });
    series.labels.template.setAll({
      fill:
        window.localStorage.getItem("theme") === "dark"
          ? am5.color(0xffffff)
          : am5.color(0x000000),
    });
    series.slices.template.adapters.add("fill", (fill, target: any) => {
      const category = target.dataItem?.get("category");
      if (category === "Youtube") return am5.color(0xef5350);
      if (category === "Twitter") return am5.color(0x42a5f5);
      if (category === "Instagram") return am5.color(0xec407a);
      if (category === "GridFinder") return am5.color(0xffa726);
      if (category === "Google") return am5.color(0x29b6f6);
      return am5.color(0x26a69a);
    });

    const tooltip = am5.Tooltip.new(root, {
      getFillFromSprite: false,
      getStrokeFromSprite: false,
      labelText: "[bold]{key}: {value}[/]\n{names}",
    });

    tooltip.label.setAll({
      maxWidth: window.innerWidth >= 1520 ? 400 : 200,
      oversizedBehavior: "wrap",
    });

    series.slices.template.adapters.add("tooltip", (tooltip, target) => {
      if (tooltip) {
        tooltip.get("background")?.setAll({
          fill: target.get("fill"),
        });
      }
      return tooltip;
    });

    series.slices.template.set("tooltip", tooltip);

    const dataArray = Object.entries(data).map(([key, value]: any) => {
      const usernames = value.map((item: any) => item.username);
      const limitedUsernames =
        usernames.length > 20
          ? usernames.slice(0, 20).join(" • ") + " • ..."
          : usernames.join(" • ");

      return {
        key,
        value: value.length,
        names: limitedUsernames,
      };
    });

    series.slices.template.set("tooltipText", "a {names}");

    series.data.setAll(dataArray);
    series.appear(1000, 100);

    return root;
  };

  if (data == null) return <LoadingContent />;
  if (typeUser < 2) return <ErrorPage />;

  return (
    <div id="data-panel" className="row">
      <div className="col-md-4">
        <div>
          <p>
            🔵 Connected NOW <b>({data.connectedLast5min.length} users)</b>
          </p>
          <i>
            {data.connectedLast5min.map((driver: any) => {
              return <label key={`b${driver.id}`}>{driver.username}• </label>;
            })}
          </i>
        </div>
      </div>
      <div className="col-md-6">
        <div>
          <p>
            🔵 Connected LAST 24H <b>({data.connectedLast24h.length} users)</b>
          </p>
          <i>
            {data.connectedLast24h.map((driver: any) => {
              return <label key={`b${driver.id}`}>{driver.username} • </label>;
            })}
          </i>
        </div>
      </div>
      <div className="col-md-2">
        <div className="combi">
          <p>Registered Users</p>
          <b>{data.total}</b>
          <p className="marginTop">Latest User</p>
          <b>{data.recent.username}</b>
        </div>
      </div>
      <div className="col-md-6">
        <div>
          <p>USERS ORIGIN</p>
          <div ref={chartRef2} style={{ width: "100%", height: "400px" }}></div>
        </div>
      </div>
      <div className="col-md-6">
        <div>
          <p>LATEST USERS ORIGIN</p>
          <div ref={chartRef} style={{ width: "100%", height: "400px" }}></div>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
